import { NgModule, ModuleWithProviders } from '@angular/core';

import { AuthService } from './auth.service';
import { AuthGuard } from './guards/auth.guard';


@NgModule({
  providers: [AuthGuard, AuthService]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootAuthModule,
      providers: [AuthService, AuthGuard],
    };
  }
}

@NgModule({
  imports: [
    AuthModule
  ],
})
export class RootAuthModule { }
